const amountTypes = [
  { title: 'باخت', id: 10 },
  { title: 'برنده', id: 9 },
  { title: 'XP', id: 8 },
  { title: 'سکه', id: 7 },
  { title: 'کاپ', id: 6 },
  { title: 'دعوت دوستان', id: 5 },
  { title: 'زمان', id: 4 },
  { title: 'کلید', id: 3 },
  { title: 'تیکت', id: 2 },
  { title: 'تومان', id: 1 },
];

export const getDefaultValues = (applicationDetails) => ({
  Title: applicationDetails?.ApplicationTitle || '',

  VAST_URL: applicationDetails?.VAST_URL || '',

  ApplicationNeedPaymentAUD: applicationDetails?.ApplicationNeedPaymentAUD ? 1 : 0,
  ApplicationNeedPaymentVIDEO: applicationDetails?.ApplicationNeedPaymentVIDEO ? 1 : 0,
  ApplicationNeedPaymentGAME: applicationDetails?.ApplicationNeedPaymentGAME ? 1 : 0,

  ApplicationSearchVIDEO: applicationDetails?.ApplicationSearchVIDEO ? true : false,
  ApplicationSearchAUD: applicationDetails?.ApplicationSearchAUD ? true : false,
  ApplicationSearchMusic: applicationDetails?.ApplicationSearchMUSIC ? true : false,
  ApplicationSearchGame: applicationDetails?.ApplicationSearchGAME ? true : false,

  ApplicationHasScreenSaver: applicationDetails?.ApplicationHasScreenSaver ? true : false,

  Desc: applicationDetails?.ApplicationDesc || '',
  LogoLight: applicationDetails?.ApplicationLogo || '',
  LogoDark: applicationDetails?.ApplicationLogoDark || '',
  Backdrop: applicationDetails?.ApplicationBackDrop || '',
  AllowLoginRegister: applicationDetails?.ApplicationAllowRegisterLogin ? true : false,
  EnableSocial: applicationDetails?.ApplicationEnableSocial ? true : false,
  ShowMenu: applicationDetails?.ApplicationShowMenu ? true : false,
  ShowHeader: applicationDetails?.ApplicationShowHeader ? true : false,
  ShowFooter: applicationDetails?.ApplicationShowFooter ? true : false,
  ApplicationShowProfileMenu: applicationDetails?.ApplicationShowProfileMenu ? true : false,
  RegisterTitle: applicationDetails?.ApplicationReigsterTitle || '',
  RegisterSubTitle: applicationDetails?.ApplicationRegisterTitleSub || '',
  LoginTitle: applicationDetails?.ApplicationLoginTitle || '',
  LoginSubTitle: applicationDetails?.ApplicationLoginTitleSub || '',
  CommentInputBoxPlaceHolder: applicationDetails?.ApplicationCommentInputPlaceHolder || '',
  GA: applicationDetails?.ApplicationGA4 || '',
  TrackerCode: applicationDetails?.ApplicationTrackerCode || '',
  TermsUrl: applicationDetails?.ApplicationRegisterTermsUrl || '',
  DefaultTheme: applicationDetails?.DefaultTheme || 'auto',
  InformationWalletTime: applicationDetails?.ApplicationInformationWalletTimeBody || '',
  LinkPlayGame: applicationDetails?.ApplicationLinkPlayGame || '',
  LinkPlayMedia: applicationDetails?.ApplicationLinkPlayMedia || '',
  LinkListPackage: applicationDetails?.ApplicationLinkListPackage || '',
  LinkListSubscribe: applicationDetails?.ApplicationLinkListSubscribe || '',
  Help: applicationDetails?.ApplicationHelp || '',
  TermsofPolicy: applicationDetails?.ApplicationTermsofPolicy || '',
  QA: applicationDetails?.ApplicationQA || '',
  WelcomePopup: applicationDetails?.ApplicationWelcomePopup || '',
  IDSShowAmountTypeInHeader:
    amountTypes.filter((item) => applicationDetails?.ApplicationIDSShowAmountTypeInHeader?.split(',').map(Number)?.includes(item.id)) || [],
  ApplicationIsLogoEnable: Boolean(applicationDetails?.ApplicationIsLogoEnable),
  ApplicationHasTheme: Boolean(applicationDetails?.ApplicationHasTheme),
});
